<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 4">
    <path
      d="M10.846.846H1.154C.516.846 0 1.361 0 2c0 .638.515 1.154 1.154 1.154h9.692a1.153 1.153 0 1 0 0-2.308Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
